import type { ButtonConfig } from '../../declare'
import { useContext } from 'react'
import { Popconfirm } from 'antd'
import { EasyIcon, TreeContext, postMsg } from 'src/components'
import { $api } from 'src/plugins'

type Props = {
  config: ButtonConfig
}
const DeleteConfirmBtn = (props: Props) => {
  const tree = useContext(TreeContext)

  const handleDelete = () => {
    const { Nav_PageTree = {} } = tree.treeConfig
    const { BATCH_DEL_API_URL } = Nav_PageTree
    if (!BATCH_DEL_API_URL) {
      postMsg('未配置删除API', 'error')
      return
    }
    $api['app/getDataByGet'](
      { ids: tree.selectedKeys.join(',') },
      { url: BATCH_DEL_API_URL }
    ).then((res: any) => {
      if (res) {
        postMsg('删除成功')
        tree.getTreeData()
      }
    })
  }

  const { LABEL, ICON } = props.config
  return (
    <Popconfirm title='确认删除？' onConfirm={handleDelete}>
      <EasyIcon title={LABEL} type={ICON} defaultIcon='DeleteOutlined' className='color-error' />
    </Popconfirm>
  )
}

export default DeleteConfirmBtn